import { object } from './type-checkers';
import { TypeChecker, wrapCreator } from './util';

const tuple = (): TypeChecker => object;

export default wrapCreator(tuple, { type: 'tuple' }, true);
